<template>
  <div class="container-devices">
    <div class="title-devices">
      <h1>Sessões por dispositivo</h1>
      <b-dropdown v-model="changeDays" aria-role="list" position="is-bottom-left">
        <button slot="trigger" slot-scope="{ active }" class="button">
          <span class="device-days">
            {{ `${(changeDays === 1) ? 'Últimas 24 horas' : 'Últimos '+changeDays+' dias'}` }}
          </span>
          <b-icon :icon="active ? 'menu-up' : 'menu-down'" />
        </button>
        <b-dropdown-item :value="1" aria-role="listitem">
          Últimas 24 horas
        </b-dropdown-item>
        <b-dropdown-item :value="7" aria-role="listitem">
          Últimos 7 dias
        </b-dropdown-item>
        <b-dropdown-item :value="30" aria-role="listitem">
          Últimos 30 dias
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="chart-container">
      <apexcharts
        class="apex-chart"
        width="200px"
        type="donut"
        :options="chartOptions"
        :series="chatData"
      />
      <div class="chart-description">
        <div v-for="date in descriptionDate" :key="date.id" class="desktop-container">
          <div class="desktop-title">
            <feather
              style="margin-right: 10px; margin-top: 10px"
              :type="date.nomeicon"
              size="15"
              :style="`color:` + color + `;`"
            />
            <h1 style="margin-right: 4px;">
              {{ date.nome }}
            </h1>
            <h4>{{ `- ${date.porcentagemCategoria}%` }}</h4>
          </div>
          <div class="desktop-percent">
            <h1>
              {{ date.porcentagem }}
              <strong style="font-size:9px;margin-right:3px;">%</strong>
            </h1>
            <feather
              style="margin-right: 10px"
              :type="date.icone"
              size="15"
              :style="`color:` + date.color + `;`"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apexcharts from 'vue-apexcharts';

export default {
	components: {
		apexcharts,
	},
	props: {
		devicesLabel: {
			type: Array,
			require: true,
			default: () => {},
		},
		data: {
			type: Array,
			require: true,
			default: () => [0, 0, 0],
		},
		descriptionDate: {
			type: Array,
			require: true,
			default: () => [],
		},
		color: {
			type: String,
			require: true,
			default: '#7159C1',
		},
		percentIcon: {
			type: String,
			require: true,
			default: '',
		},
		icon: {
			type: String,
			require: true,
			default: '',
		},
		title: {
			type: String,
			require: true,
			default: '',
		},
		vuewidth: {
			type: String,
			require: true,
			default: '20%',
		},
	},
	data() {
		return {
			changeDays: 1,
		};
	},
	computed: {
		chatData() {
			return this.data;
		},
		chartOptions() {
			return {
				chart: {
					width: 200,
					type: 'donut',
				},
				plotOptions: {
					pie: {
						startAngle: -45,
					},
				},
				labels: this.devicesLabel,
				dataLabels: {
					enabled: false,
				},
				fill: {
					type: 'gradient',
				},
				legend: {
					show: false,
				},
			};
		},
	},
	watch: {
		changeDays(e) {
			this.$emit('change', e);
		}
	},
};
</script>

<style scoped>
.chart-description {
  display: flex;
  flex-direction: column;
}
.container-devices {
  background-color: #fff;
  width: 31%;
  padding: 20px;
  justify-content: space-between;
  border-radius: 5px;
  border: 1px solid #deebfd;
  box-shadow: -8px 12px 18px 0 #dadee8;
}
.title-devices {
  display: flex;
  justify-content: space-between;
}
.title-devices h1 {
  font-size: 16px;
}

.button {
  all: unset;
  align-items: center;
  display: flex;
  padding-left: 5px;
  padding-right: 5px;
}
.device-days {
  font-size: 10px;
}
.chart-container {
  margin-top: 20px;
}
.desktop-container {
  display: flex;
  justify-content: space-between;
}
.desktop-title {
  display: flex;
  align-items: center;
}
.desktop-title h1 {
  font-size: 10px;
  font-weight: bold;
}
.desktop-title h4 {
  font-size: 10px;
}
.desktop-percent {
  display: flex;
  align-items: center;
}
.desktop-percent h1 {
  font-size: 10px;
}
.apex-chart {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
